import { useCallback } from 'react';

import { TTransformedUser } from '@/shared/features/rbac/hooks/use-users-transformer/use-users-transformer.types';
import { UserFragment } from '@/shared/types/types.generated';
import { getFullname } from '@/shared/utils/format';

export const useUsersTransformer = () => {
  const transformUser = useCallback((user: UserFragment): TTransformedUser => {
    const roleTags = user.userRoles.items.map(({ name }) => ({ name }));

    return {
      userId: user.userId,
      name: getFullname(user),
      firstName: user.firstName,
      lastName: user.lastName,
      companyName: user.companyName,
      email: user.email,
      source: user.source,
      userRoles: user.userRoles,
      roleTags,
      groupId: user.groupId,
      raw: user,
    };
  }, []);

  return { transformUser };
};
